module.exports = __webpack_public_path__ + "static/img/geometry1.8aa180bb.jpg";